import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import router from './router';
import './firebase';
import { firestorePlugin } from 'vuefire';
import Vue2Filters from 'vue2-filters';

Vue.use(Vue2Filters);
Vue.use(firestorePlugin);


Vue.config.productionTip = false;

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app');
